import SubVisual from '@/components/SubVisual';
import useEvent from '@/pages/customer-support/event/hook/useEvent';

const EventPage = () => {
	useEvent();
	return (
		<main id="sub" className="sub event hidden">
			<section className="sub-visual">
				<SubVisual cate={'이벤트'} title={'파로스의 이야기를 들어보세요'} />
			</section>
			<section id="" className="sub-content">
				<div className="sub-inner">
					<div className="card-wrap board js-ongoing">
						<p className="card-list-title">진행중인 이벤트</p>
						<ul
							className="card-list"
							data-template='
							<li>
							<div class="card-thumbnail">
							<!-- <img src="" alt=""> -->
							</div>
							<div class="card-info">
							<p class="title"><!-- title --></p>
							<span class="desc"><!-- desc --></span>
							<div class="date">
							<span class="js-event-stDt"><!-- 시작일 --></span> ~ <span class="js-event-edDt"><!-- 종료일 --></span>
							</div>
							</div>
							</li>'></ul>
						<div className="nodata-box">진행중인 이벤트가 없습니다.</div>
						<div className="board-pagination">
							<button className="pagination-btn btn-prev"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn btn-next"></button>
						</div>
					</div>

					<div className="card-wrap board done js-ended">
						<p className="card-list-title">종료된 이벤트</p>
						<ul
							className="card-list"
							data-template='
							<li>
							<div class="card-thumbnail">
							<!-- <img src="" alt=""> -->
							</div>
							<div class="card-info">
							<p class="title"><!-- title --></p>
							<span class="desc"><!-- desc --></span>
							<div class="date">
							<span class="js-event-stDt"><!-- 시작일 --></span> ~ <span class="js-event-edDt"><!-- 종료일 --></span>
							</div>
							</div>
							</li>'></ul>
						<div className="nodata-box">종료된 이벤트가 없습니다.</div>
						<div className="board-pagination">
							<button className="pagination-btn btn-prev"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn"></button>
							<button className="pagination-btn btn-next"></button>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
};

export default EventPage;
